import Typography from 'components/Typography';
import Card from 'components/Card';
import CardContent from 'components/CardContent';

import {Customer, OrderType} from 'types';
import {getFullName} from 'helpers/user';

import styles from '../RequestDetails.module.scss';
import {Link} from 'react-router-dom';
import {Address} from './DeliveryAdressType';
import {get} from 'lodash';
import {ExternalLinkIcon} from './icons/external-link';
import ButtonWithIcon from 'components/ButtonWithIcon';
import {
  EditIcon,
  PhoneIcon,
} from 'pages/DeliveryPlanner/components/OrderDetailsModal/icons';
import {PinIcon} from 'pages/DeliveryPlanner/components/Ticket/pin';
import useCompanyConfig from 'hooks/useCompanyConfig';

interface Props {
  pharmacy: {
    name: string;
    phone: string;
    address: string;
  };
  customer: Customer;
  deliveryData: Address;
  orderType: OrderType;
  modalHandler: () => void;
}

function CustomerDetails({
  customer,
  deliveryData,
  modalHandler,
  orderType,
}: Props) {
  const {isPickupDropoff} = useCompanyConfig();
  const isVendor = customer?.client_role === 'vendors';
  return (
    <Card className={styles.card}>
      <CardContent pt="md">
        <div className={styles.info}>
          <div className={styles.row}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>
                {isPickupDropoff && orderType === 'pickup'
                  ? 'Vendor'
                  : 'Customer'}
              </h2>
            </div>
            {!!get(customer, 'patient_no', null) && (
              <Typography className={styles.text} component="p" variant="label">
                #{get(customer, 'patient_no', null)}
              </Typography>
            )}
          </div>
          <Link to={`/people/customers/${customer.id}/edit`}>
            <Typography className={styles.fullname} component="p" variant="h2">
              {isVendor
                ? customer?.customer_company
                : getFullName(customer.user)}
              <ExternalLinkIcon color="#1A6AE5" className={styles.detailIcon} />
            </Typography>
          </Link>
        </div>

        <div className={styles.customerDetail}>
          <PhoneIcon className={styles.detailIcon} />
          {customer?.user?.phone}
        </div>
        <div className={styles.customerDetails}>
          <div className={styles.customerDetail}>
            <PinIcon className={styles.detailIcon} />
            {get(deliveryData, 'address_line_1', '')},{' '}
            {get(deliveryData, 'city', '')}, {get(deliveryData, 'state', '')},{' '}
            {get(deliveryData, 'zipcode', '')}
            {get(deliveryData, 'unit_address', '')
              ? `, ${get(deliveryData, 'unit_address', '')}`
              : ''}
          </div>
          <ButtonWithIcon
            color="ghost"
            size="sm"
            onClick={modalHandler}
            icon={<EditIcon />}
            iconSize={16}
          />
        </div>
      </CardContent>
    </Card>
  );
}

export default CustomerDetails;
